module.exports = __webpack_public_path__ + "img/squirrel.17d3e0c6.jpg";